import React from 'react';
import { ContextLayout } from '../../context-provider';
export default function IconCheckBold(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$useCurrentColo = props.useCurrentColor,
      useCurrentColor = _props$useCurrentColo === void 0 ? true : _props$useCurrentColo,
      style = props.style;
  return /*#__PURE__*/React.createElement(ContextLayout, null, function (_ref) {
    var prefixCls = _ref.prefixCls;
    return /*#__PURE__*/React.createElement("svg", {
      className: prefixCls + "-icon " + prefixCls + "-icon-check-bold " + className,
      width: "1em",
      height: "1em",
      style: style,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 -0.9699999999999998 10.07 10.07"
    }, /*#__PURE__*/React.createElement("g", {
      "data-name": "\u56FE\u5C42 2"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M9.22.12a.49.49 0 00-.7.06L3.86 5.69 1.4 3.57a.51.51 0 00-.71.06l-.57.66A.49.49 0 00.17 5L3 7.38v.07l.69.55a.53.53 0 00.71 0l.6-.71a.22.22 0 000-.08l5-5.82a.51.51 0 00-.11-.71z",
      fill: useCurrentColor ? "currentColor" : "#000000",
      fillRule: "evenodd",
      "data-name": "\u56FE\u5C42 1"
    })));
  });
}